<template>
    <div>
        <div v-if="!!inputLbl.name" class="text-base mb-10px text-primary">{{ inputLbl.name }}</div>
        <div class="relative" ref="dropdown-btn" :class="[hideDetails ? 'pb-0' : 'pb-5']">
            <!-- Dropdown btn -->
            <button
                type="button"
                class="w-full px-3 py-6px h-10 placeholder-gray-500 rounded-md appearance-none border"
                :class="[isError ? 'border-red-500' : 'border-primary', disabled ? 'bg-disabled' : 'bg-white']"
                @click="toggleDropdown()"
            >
                <span :class="[arrow ? 'flex justify-between w-full items-center' : '']">
                    <span
                        class="text-black-1"
                        v-if="itemSelected == null"
                    >{{ inputLbl.placeholder }}</span>
                    <span v-else class="text-black-1">{{ itemSelected[itemTextKey] }}</span>
                    <template v-if="arrow">
                        <svg
                            class="h-5 w-5 inline-flex transform -rotate-90"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M 15 19 l -7 -7 7 -7"
                            />
                        </svg>
                    </template>
                </span>
            </button>
            <!-- item list -->
            <div
                v-show="showList && itemList.length > 0"
                ref="ddl-list-area"
                class="absolute left-0 w-full bg-white border rounded-md overflow-hidden z-index-dropdown shadow"
                :class="[isBottomDropdown ? 'top-10 mt-1' : 'bottom-16 mb-1']"
            >
                <div class="max-h-64 overflow-y-auto hide-scrollbar">
                    <div
                        v-for="(v) in itemList"
                        :key="v[itemValueKey]"
                        class="py-2 px-4 border-b last:border-b-0 cursor-pointer hover:bg-gray-50 text-center"
                        @click="selectItem(v)"
                    >{{ v[itemTextKey] }}</div>
                </div>
            </div>
            <!-- error msg -->
            <div
                class="text-red-500 text-sm absolute bottom-0 left-0"
                v-if="isError && !hideDetails"
            >{{ getErrorMsg }}</div>
        </div>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Array} itemList (required) list of dropdown item { key: '', value: '' }
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isFirstSave (optional) Show/Hide Error after save.
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputDropdown",
    props: {
        //v-model
        inputValue: { type: [String, Number] },
        itemList: { type: Array, required: true },
        //props
        errorInfo: { type: Object, required: true },
        isFirstSave: { type: Boolean, default: true },
        isShowErrorLbl: { type: Boolean, default: false },
        //text
        inputLbl: { type: Object, required: true },
        arrow: { type: Boolean },
        parentError: { type: Boolean },
        hideDetails: { type: Boolean },
        itemValueKey: {
            type: String,
            default: "value"
        },
        itemTextKey: {
            type: String,
            default: "text"
        },
        disabled: {
            type: Boolean
        }
    },
    emits: ["onChange", "update:inputValue"],
    data: function () {
        return {
            content: this.inputValue,
            showList: false,
            itemSelected: null,

            isBottomDropdown: true,
        };
    },
    computed: {
        isError: function () {
            if (this.parentError) return true

            if (this.isShowErrorLbl && !this.isFirstSave && !this.errorInfo.isValid) {
                return true;
            }
            return false;
        },
        getErrorMsg: function () {
            if (this.parentError) return ''

            if (this.isShowErrorLbl && !this.isFirstSave && !this.errorInfo.isValid) {
                return this.errorInfo.msg;
            }
            return '';
        },
    },
    watch: {
        inputValue: function (val) {
            // console.log(val, this.itemList)
            this.content = val
            this.setSelectedDropdown()
            this.validateInput()
        },
        itemList: function () {
            this.setSelectedDropdown()
            this.validateInput()

            // console.log(this.itemList, this.content)
        }
    },
    mounted: function () {
        this.setSelectedDropdown();
        this.validateInput();
    },
    methods: {
        setSelectedDropdown: function () {
            let item = this.itemList.find((obj) => {
                return obj[this.itemValueKey] == this.content;
            });
            if (item != null) {
                this.itemSelected = item;
            }
        },

        toggleDropdown: function () {
            if (this.disabled) return

            if (this.showList) {
                this.closeDropdown();
            } else {
                this.openDropdown();
            }
        },
        openDropdown: function () {
            this.isBottomDropdown = true;
            this.showList = true;
            document.addEventListener('click', this.documentClick);

            this.$nextTick(() => {
                let elem = this.$refs['ddl-list-area'];
                let bottom = elem.getBoundingClientRect().bottom;
                let windowHeight = window.innerHeight;

                this.isBottomDropdown = bottom < windowHeight;
            });
        },
        closeDropdown: function () {
            this.showList = false;
            document.removeEventListener('click', this.documentClick);
        },
        documentClick: function (e) {
            let el = this.$refs['dropdown-btn'];
            var target = e.target;

            if (el !== target && !el.contains(target)) {
                this.closeDropdown();
            }
        },

        selectItem: function (item) {
            this.content = item[this.itemValueKey];
            this.itemSelected = item;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);

            this.$emit("onChange")
        },

        clearSelect: function () {
            this.content = "";
            this.itemSelected = null;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },

        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            //Set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            //Required
            if (this.inputLbl.required && this.itemSelected == null) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
        },

        setValue: function (value) {
            this.content = value;
            this.setSelectedDropdown();
            this.validateInput();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
</style>
